var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
const baseUrl = "/aviso/ResidencyStatus";
export default class ResidencyStatusService {
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            return ResidencyStatusService.search({
                // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
                ids,
                active: true,
            }).then(({ data }) => data);
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getPagedResponse(baseUrl + "/search", {
                query: search.query,
                active: search.active,
                ids: search.ids,
                codes: search.codes,
                residencyStatusIds: search.residencyStatusIds,
                srcSystemIds: search.srcSystemIds,
                names: search.names,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
        });
    }
}
